/**
 * @generated SignedSource<<98cad417a07911384d9841e4f54471cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorShortBioArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly shortBio: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "authorShortBioArticle";
};
export type authorShortBioArticle$key = {
  readonly " $data"?: authorShortBioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorShortBioArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorShortBioArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortBio",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "6a8b7e06269fcb395cb13ec686ce0c83";

export default node;
